import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Article } from '../../types/blog';

interface ArticleNavigationProps {
  prev: Article | null;
  next: Article | null;
}

const ArticleNavigation: React.FC<ArticleNavigationProps> = ({ prev, next }) => {
  return (
    <div className="mt-12 pt-8 border-t border-gray-200">
      <div className="flex justify-between items-center">
        {prev && (
          <Link 
            to={`/blog/${prev.id}`}
            className="flex items-center text-gray-600 hover:text-gray-900"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            <div>
              <div className="text-sm text-gray-500">Article précédent</div>
              <div className="font-medium">{prev.title}</div>
            </div>
          </Link>
        )}
        {next && (
          <Link 
            to={`/blog/${next.id}`}
            className="flex items-center text-right text-gray-600 hover:text-gray-900"
          >
            <div>
              <div className="text-sm text-gray-500">Article suivant</div>
              <div className="font-medium">{next.title}</div>
            </div>
            <ArrowRight className="w-4 h-4 ml-2" />
          </Link>
        )}
      </div>
    </div>
  );
};

export default ArticleNavigation;